var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-base',{attrs:{"width":_vm.size + 'px',"fill":_vm.color,"viewBox":"0 0 100 100"}},[_c('path',{attrs:{"d":"M20,55 L40,75 L77,27","fill":"none","stroke":_vm.color,"stroke-width":"15","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }